module.exports = __webpack_public_path__ + "static/media/success2.6abaec25.svg";